(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define("LogicCloudEcoBot", ["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["LogicCloudEcoBot"] = factory(require("jQuery"));
	else
		root["LogicCloudEcoBot"] = factory(root["jQuery"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2__) => {
return 